import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M16 3h5v5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 3H3v5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m15 9 6-6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Split";
const Split = memo(themed(Icon));
export {
  Split
};
//# sourceMappingURL=split.js.map
